import React from 'react';
import { connect } from 'react-redux';
import { deleteJenjang } from './redux/reduxApi';
import { closeModal } from '../../../app/modals/redux/modalActions';
import useScreenWidth from '../../../app/common/helpers/useScreenWidth';
import Modal from '../../../ui/Modal';
import Button from '../../../ui/Button';

const actions = {
  closeModal,
  deleteJenjang,
};

function ModalDeleteItem({ data, deleteJenjang, closeModal }) {
  const auth = data?.auth;
  const history = data?.history;
  const item = data?.item;
  const id = item?.id;
  const screenWidth = useScreenWidth();

  function handleDelete() {
    deleteJenjang({ auth, history, id });
    closeModal();
  }

  return (
    <Modal
      variant='danger'
      closeModal={closeModal}
      width={screenWidth > 500 ? 500 : screenWidth}
    >
      <p className='px-4 my-5 mx-1'>
        Apakah Anda yakin ingin menghapus jenjang{' '}
        <span className='has-text-danger has-text-weight-semibold'>{`${item.title}`}</span>{' '}
        ?
      </p>
      <div className='flex justify-end align-center pt-2'>
        <div className='buttons'>
          <Button cvariant='cdelete' onClick={handleDelete} />
          <Button cvariant='cback' onClick={closeModal} />
        </div>
      </div>
    </Modal>
  );
}

export default connect(null, actions)(ModalDeleteItem);
